var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-header"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas",class:'fa-' + _vm.icon})]),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }